import { createFeature, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { SsoOidcDto } from '../dtos/ssoOidcDto.interface';
import * as SsoActions from './../actions/sso.actions';

export interface SsoState {
    currentProvider: SsoOidcDto | null;
    loading: boolean;
    error: any;
}

export const initialState: SsoState = {
    currentProvider: null,
    loading: false,
    error: null,
};

export const selectSsoFeature = createFeatureSelector<SsoState>('aumicoSso');

export const selectCurrentSsoProvider = createSelector(selectSsoFeature, (state) => state.currentProvider);

export const selectSsoLoading = createSelector(selectSsoFeature, (state) => state.loading);

export const selectSsoError = createSelector(selectSsoFeature, (state) => state.error);

export const ssoReducer = createReducer(
    initialState,
    on(SsoActions.loadSsoProvider, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),
    on(SsoActions.loadSsoProviderSuccess, (state, { provider }) => ({
        ...state,
        loading: false,
        currentProvider: provider,
    })),
    on(SsoActions.loadSsoProviderFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error,
    })),
);

export const ssoFeature = createFeature({
    name: 'aumicoSso',
    reducer: ssoReducer,
});
